<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="nomenclature.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Родительская группа</label>
            <crm-nomenclature-group-single-select
              [(selectedNomenclature)]="nomenclature.parent"
              [nomenclatures]="nomenclatures"
              [showClear]="true"
              appendTo="body"></crm-nomenclature-group-single-select>
            <small
              *ngIf="errors?.parent"
              class="p-error">
              {{ errors.parent | join }}
            </small>
          </div>

          <div
            *ngIf="nomenclature?.deleted"
            class="text-right">
            <p-tag
              severity="danger"
              value="Удалена"
              styleClass="mt-2"></p-tag>
          </div>
        </div>
      </p-card>

      <div
        class="mt-3"
        *ngIf="formStoreService.getState.forms[this.index]?.isEdit">
        <crm-directory-common-history
          [entityName]="DirectoryCommonHistoryTypeEnum.NOMENCLATURE_GROUP"
          [entityId]="formStoreService.getState.forms[this.index]?.entityId"
          [apiService]="nomenclatureGroupService">
        </crm-directory-common-history>
      </div>
    </div>
  </div>

  <div
    *ngIf="(form$ | async)?.canWrite"
    class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveNomenclature()"></crm-button>

      <div class="flex align-items-center gap-2">
        <crm-button
          *ngIf="(form$ | async)?.isShowDelete && !nomenclature?.deleted"
          label="Удалить"
          styleClass="p-button-danger p-button-text"
          (onClick)="deleteNomenclature()"></crm-button>
        <crm-button
          *ngIf="(form$ | async)?.isShowDelete && nomenclature?.deleted"
          icon="pi pi-undo"
          label="Восстановить"
          styleClass="p-button-info p-button-text"
          (onClick)="restoreNomenclature()"></crm-button>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
